(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuchi-product-picks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.nuchiPdpRecommendationsV1) return;
    window.nuchiPdpRecommendationsV1 = true;
    const roots = Array.from(document.querySelectorAll('[data-npr]'));
    const params = new URLSearchParams(location.search);
    const isQA = params.has('qa_run') || params.has('preview_theme_id') || location.hostname.endsWith('.shopifypreview.com') || window.Shopify?.theme?.role === 'unpublished';
    function allowed() {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return Boolean(privacy && privacy.analyticsProcessingAllowed && privacy.analyticsProcessingAllowed());
    }
    function emit(name, data) {
      if (!allowed() || typeof window.gtag !== 'function') return false;
      window.gtag('event', name, Object.assign({send_to:'G-Z8G8ZZ1L9E', measurement_version:'pdp_relevance_20261012', transport_type:'beacon'}, isQA ? {traffic_type:'internal',debug_mode:true} : {}, data));
      return true;
    }
    roots.forEach(root => {
      const context = {source_product_id:root.dataset.nprSource, recommendation_group:root.dataset.nprGroup};
      const cards = Array.from(root.querySelectorAll('[data-npr-target]'));
      const seen = new Set();
      const visible = new Set();
      let eligible = false, arrived = false, attempts = 0;
      const timers = new Map();
      function observeCard(card) {
        clearTimeout(timers.get(card));
        if (seen.has(card) || !visible.has(card) || document.visibilityState !== 'visible') return;
        timers.set(card,setTimeout(() => {
          if (seen.has(card) || !visible.has(card) || document.visibilityState !== 'visible') return;
          if (emit('nuchi_pdp_rec_view',Object.assign({},context,{target_product_id:card.dataset.nprTarget,position:Number(card.dataset.nprPosition)}))) seen.add(card);
        },1000));
      }
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio >= .5) visible.add(entry.target); else visible.delete(entry.target);
          observeCard(entry.target);
        });
      },{threshold:[0,.5]});
      cards.forEach(card => {
        observer.observe(card);
        if (isQA) {
          const destination = new URL(card.href);
          destination.searchParams.set('qa_run','nuchi_rec_20261012');
          card.href = destination.href;
        }
        card.addEventListener('click',() => {
          emit('nuchi_pdp_rec_click',Object.assign({},context,{target_product_id:card.dataset.nprTarget,position:Number(card.dataset.nprPosition)}));
        });
      });
      function start() {
        if (!eligible) eligible = emit('nuchi_pdp_rec_eligible',context);
        const origin = params.get('prsrc');
        if (!arrived && params.get('ref') === 'pdp-pick' && /^\d{10,16}$/.test(origin || '')) {
          arrived = emit('nuchi_pdp_rec_arrival',{source_product_id:origin,target_product_id:root.dataset.nprSource});
        }
        visible.forEach(observeCard);
        if (!eligible && ++attempts < 30) setTimeout(start,500);
      }
      document.addEventListener('visitorConsentCollected',start);
      document.addEventListener('visibilitychange',() => visible.forEach(observeCard));
      if (window.Shopify && !window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function' && !window.__nuchiPrivacyLoading) {
        window.__nuchiPrivacyLoading = true;
        window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],start);
      }
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
